interface TestData {
  id?: number;
  name?: string;
  type?: string;
  translations?: any;
  metrics? : any;
  borg_metric_id?: number;
}

export class Test {
  public static readonly TYPE_POWER: string = 'power';
  public static readonly TYPE_POWER_JUMP: string = 'power-jump';
  public static readonly TYPE_REVERSAL_JUMP_DEEP: string = 'reversal-jump-deep';
  public static readonly TYPE_REVERSAL_JUMP_SHORT: string = 'reversal-jump-short';
  public static readonly TYPE_BILATERAL: string = 'bilateral';
  public static readonly TYPE_REACTIVITY: string = 'reactivity';
  public static readonly TYPE_LOWER_LIMB_STRENGTH: string = 'lower-limb-strength';
  public static readonly TYPE_UPPER_LIMB_STRENGTH: string = 'upper-limb-strength';

  public static getNonTranslatableFields(): string[] { return ['id', 'type']; }
  public static getTranslatableFields(): string[] { return ['name']; }
  public static getFields(): string[] { return ['id', 'name', 'type']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  name?: string;
  type?: string;
  translations?: any;
  metrics? : any;
  borg_metric_id?: number;

  public static fromApi(data: TestData): Test {
    let translationData: any = {};
    if (data.translations) {
      for (let i = 0; i < data.translations?.length; i++) {
        if (data.translations[i]['test_id'] === data['id']) {
          translationData = data.translations[i];
          i = data.translations?.length;
        }
      }
    }
    return new Test({
      id: data.id,
      name: translationData.name ?? data.name,
      type: data.type,
      borg_metric_id: data.borg_metric_id,
      metrics: data.metrics,
      translations: data.translations
    });
  }

  public static fromApiArray(data: TestData[]): Test[] {
    return data.map((item: TestData) => Test.fromApi(item));
  }

  constructor({id, name, type, borg_metric_id, metrics, translations} : TestData) {
    this.id = id;
    this.name = name;
    this.type = type;
    this.borg_metric_id = borg_metric_id;
    this.metrics = metrics;

    this.translations = translations;
  }

  public toJson(): TestData {
    return {
      id: this.id,
      name: this.name,
      type: this.type
    };
  }
}
